import type { RoleListItem } from '../roleTypes';

type RoleState = Pick<RoleListItem, 'isSystem' | 'isActive' | 'userCount'>;

/*
  Why a role's Edit and Delete are DISABLED — STATE, not permission, so they are disabled with
  a sentence rather than hidden. One definition for the list's row menu and the profile's cog,
  so the two cannot disagree. Each mirrors a refusal `RoleService` already makes; the server
  stays the authority.
*/

/** `RoleService.UpdateAsync` refuses to rename a system role. */
export function roleEditDisabledReason(role: Pick<RoleState, 'isSystem'>): string | null {
  return role.isSystem ? 'A system role cannot be renamed.' : null;
}

/** Admin is granted the whole catalog on every boot, so an edit to it would be undone. */
export function rolePermissionsDisabledReason(role: Pick<RoleListItem, 'name'>): string | null {
  return role.name === 'Admin' ? 'Admin always holds every permission and cannot be edited.' : null;
}

/**
 * `RoleService.DeactivateAsync` refuses a system role and a role somebody still holds.
 *
 * The holders are not COUNTED in the sentence: the count is account data, gated on
 * `users.read`, and a reader without that key must not learn it from a disabled reason.
 */
export function roleDeleteDisabledReason(role: RoleState): string | null {
  if (role.isSystem) return 'A system role cannot be deleted.';
  if (!role.isActive) return 'This role is already deleted.';
  if (role.userCount > 0) return 'Accounts still hold this role. Reassign them before deleting it.';
  return null;
}
